import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@aiwyn/shared';
import { getFileIcon } from 'src/app/shared/components/file-manager/file-manager.utils';

@Component({
  selector: 'awn-file-item-icon',
  imports: [CommonModule, SharedModule],
  templateUrl: './file-item-icon.component.html',
  styleUrl: './file-item-icon.component.scss',
})
export class FileItemIconComponent {
  fileName = input<string>();
  fileExtension = input<string>();
  iconName = input<string>();
  iconNamespace = input<string>();
  cssClasses = input<'error'[]>();

  icon = computed(() => {
    let iconName = this.iconName();
    let iconNamespace = this.iconNamespace();
    let coloredIcon = false;

    if (!iconName) {
      const extension = (this.fileExtension() ?? this.fileName())?.toLowerCase()?.split('.').at(-1);
      iconName = getFileIcon(extension);
      iconNamespace = null;
      coloredIcon = true;
    }

    return {
      name: iconName,
      namespace: iconNamespace ?? null,
      combinedClasses: [...(this.cssClasses() ?? []), coloredIcon ? 'no-color' : ''],
    };
  });
}
